// extracted by mini-css-extract-plugin
var _1 = "gb9DC";
export { _1 as "projectTable" }
